import * as React from 'react'
import { Column, ColumnValue } from './types'
import FieldInput from './inputs'

interface CustomFieldInputProps {
  column: Column
  value: ColumnValue
  onChange: (value: string | number | string[] | null) => void
}

export default function CustomFieldInput({
  column,
  value,
  onChange,
}: CustomFieldInputProps) {
  // Don't convert null to '' for Select columns since they expect null for "no selection"
  const rawValue = value?.value
  const currentValue =
    column.type === 'Projects::Columns::Select' ? rawValue ?? null : rawValue ?? ''
  const fieldId = `custom_field_${column.id}`

  return (
    <div className="form-group row string">
      <label
        htmlFor={fieldId}
        className={`col-sm-3 col-form-label${column.required ? ' required' : ''}`}
      >
        {column.label}
        {column.required && <abbr title="required">*</abbr>}
      </label>
      <div className="col-sm-9">
        <FieldInput
          column={column}
          value={currentValue}
          onChange={onChange}
          fieldId={fieldId}
        />
      </div>
    </div>
  )
}
